import React from 'react';

interface Props {
  text: string;
}

export default function ErrorStrip({ text }: Props) {
  return (
    <div style={{
      background: '#FEF2F2',
      border: '1px solid #FCA5A5',
      borderRadius: 8,
      padding: '10px 12px',
      marginTop: 14,
      color: '#991B1B',
      fontSize: 13,
      fontWeight: 600,
    }}>
      {text}
    </div>
  );
}